//
// # GenAlphaModel Namespace
//

// Re-exports
export {
  exhaust,
  result,
  Result,
  AsyncResult,
  Ok,
  Err,
  validate,
  Validator,
  InnerValidator,
  gitinfo,
  GitInfo,
  uuid,
  Uuid,
  UuidMap,
  requests,
  Requests,
  RequestsError,
} from "CoreUtils";

// export * as errors from "./errors";

export * as core from "./core";
export * as xform from "./core/xform";
export {
  Direction,
  LineSegment,
  Orientation,
  Rotation,
  Size,
  Xform,
} from "./core";

export { SchematicChange, LayoutChange, SymbolChange, Change } from "./change";
export * as change from "./change";

// Export the `graphics` namespace
export * as graphics from "./graphics";
// And a few select key entries
export * as text from "./graphics/text";
export { Point, Bbox } from "./graphics";

export * from "./ident";
export * as ident from "./ident";
export * from "./content";
export * as content from "./content";

export * as sch from "./schematic";
export * as schematic from "./schematic";
export {
  Eval,
  Expr,
  ExprKind,
  Instance,
  InstParamSpec,
  Manhattan,
  ManhattanSegment,
  SymbolPin,
  SolderDot,
  WireSegment,
  Schematic,
  SchematicJson,
  Symbol,
  SymbolJson,
} from "./schematic";
export { SchematicInstanceBuilder } from "./schematic/instanceBuilder";

export * as circuit from "./circuit";

export * as layout from "./layout";
export { LayoutInstanceBuilder } from "./layout/instanceBuilder";
export { inferRectangular } from "./layout/abuttedArray";

export * as cell from "./cell";
export {
  Cell,
  ViewKind,
  contentKindToViewKind,
  viewKindToContentKind,
} from "./cell";

export { IdMap, randomId } from "./id";
export { CRDTMap } from "./crdt_map";
export type { IEntityMap, HasId } from "./entity_map";
export {
  createEntityMap,
  isCRDTMap,
  type EntityMapConfig,
} from "./entity_map_factory";

export { Builtin } from "./builtins/library";
